import React from 'react';
import { NumberInput } from '..';
import { Grid2 } from '@mui/material';
import { TypographyStyled } from './styles';
import { PlaceholderGrid } from '../../../../styles/globalStyles';
import { TypographyStyledSubHead } from '../styles';

export const DoubleNumberCard = ({
  title,
  subHead1,
  subHead2,
  subHead3,
  value1,
  value2,
  range1,
  range2,
  decimalRequired1,
  decimalRequired2,
  plusSymbolRequired1,
  plusSymbolRequired2,
  incrementDecrementVal1,
  incrementDecrementVal2,
  setValue1,
  setValue2
}: {
  title: string;
  subHead1: string;
  subHead2: string;
  subHead3?: string;
  value1: number;
  value2: number;
  plusSymbolRequired1?: boolean;
  plusSymbolRequired2?: boolean;
  decimalRequired1?: boolean;
  decimalRequired2?: boolean;
  incrementDecrementVal1?: number;
  incrementDecrementVal2?: number;
  range1?: { min: number; max: number };
  range2?: { min: number; max: number };
  setValue1: (val: number) => void;
  setValue2: (val: number) => void;
}) => {
  return (
    <PlaceholderGrid container marginTop={'1.25rem'}>
      <TypographyStyled
        variant="h5"
        sx={{
          fontSize: '0.875rem',
          lineHeight: '1.125rem',
          fontFamily: 'BGBold'
        }}
      >
        {title}
      </TypographyStyled>
      {subHead3 && (
        <TypographyStyledSubHead>{subHead3}</TypographyStyledSubHead>
      )}
      <Grid2 display={'flex'}>
        <NumberInput
          subHeading={subHead1}
          marginVal={'45px'}
          plusSymbolRequired={plusSymbolRequired1}
          incrementDecrementVal={incrementDecrementVal1}
          decimalRequired={decimalRequired1}
          value={value1}
          range={range1}
          setValue={setValue1}
        />
        <NumberInput
          subHeading={subHead2}
          value={value2}
          plusSymbolRequired={plusSymbolRequired2}
          incrementDecrementVal={incrementDecrementVal2}
          decimalRequired={decimalRequired2}
          range={range2}
          setValue={setValue2}
        />
      </Grid2>
    </PlaceholderGrid>
  );
};
